import directoryActions from './directory';

export default {
    loadExhibitors: directoryActions.load,
    setFilterParams: function(eventId, tags, recommendedFilter) {
        return {type: 'EVENT_EXHIBITORS_SET_FILTER_PARAMS', eventId, tags, recommendedFilter};
    },
    setFilter: function(eventId, filter) {
        return {type: 'EVENT_EXHIBITORS_SET_FILTER' , eventId, filter};
    },
    setFilterText: function(eventId, text) {
        return {type: 'EVENT_EXHIBITORS_SET_FILTER_TEXT', eventId, text};
    },
    addFilterTagOption: function(eventId, tag, option) {
        return {type: 'EVENT_EXHIBITORS_ADD_FILTER_TAG_OPTION', eventId, tag, option};
    },
    removeFilterTagOption: function(eventId, tag, option) {
        return {type: 'EVENT_EXHIBITORS_REMOVE_FILTER_TAG_OPTION', eventId, tag, option};
    },
    clearFilterTags: function(eventId) {
        return {type: 'EVENT_EXHIBITORS_CLEAR_FILTER_TAGS', eventId};
    },
    clearFilter: function(eventId) {
        return {type: 'EVENT_EXHIBITORS_CLEAR_FILTER', eventId};
    },
    applyRecommendedFilter: function(eventId) {
        return {type: 'EVENT_EXHIBITORS_APPLY_RECOMMENDED_FILTER', eventId};
    }
};
